{
  "common": {
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "remove": "X",
    "edit": "Editar",
    "restore": "Recuperar",
    "back": "Atrás",
    "submit": "Enviar",
    "continue": "Continuar",
    "save": "Guardar",
    "done": "Hecho",
    "home": "Inicio",
    "noData": "No hay datos.",
    "confirm": "Confirmar",
    "more": "más",
    "close": "Cerrar",
    "loading": "Cargando",
    "menu": "Menú",
    "reset": "Restablecer",
    "search": "Buscar",
    "add": "Agregar",
    "breadcrumbs": "breadcrumbs",
    "selectFile": "Seleccionar archivo",
    "clear": "Limpiar",
    "loaded": "Cargado",
    "results": "Resultados",
    "of": "de"
  },
  "pageMetaResolver": {
    "category": {
      "title": "Buscar {{query}} | AndesMotor",
      "title_other": "Buscar {{query}} | AndesMotor"
    },
    "checkout": {
      "title": "Checkout"
    },
    "search": {
      "title": "Buscar {{query}} | AndesMotor",
      "title_other": "Buscar {{query}} | AndesMotor",
      "findProductTitle": "{{count}} result for coupon \"{{coupon}}\"",
      "findProductTitle_other": "{{count}} results for coupon \"{{coupon}}\"",
      "default_title": "All products"
    },
    "product": {
      "description": "{{description}}",
      "heading": "{{heading}}",
      "title": "{{title}}"
    }
  },
  "spinner": {
    "loading": "Cargando..."
  },
  "navigation": {
    "categoryNavLabel": "Category menu",
    "footerNavLabel": "Footer links",
    "navigateTo": "Navigate to {{nav}}",
    "scrollToTop": "Scroll back to the top of the page"
  },
  "searchBox": {
    "placeholder": "Estoy buscando",
    "productSearch": "Buscar un producto",
    "ariaLabelInput": "Buscar aqui...",
    "ariaLabelSuggestions": "sugerencias de busqueda",
    "ariaLabelProducts": "resultados de productos",
    "initialDescription": "Cuando hay resultados de autocompletado, use las flechas arriba y abajo para revisar y Enter para seleccionar. En dispositivos tactiles, explore con el dedo o con gestos.",
    "suggestions": "Palabras sugeridas",
    "products": "Productos recomendados",
    "suggestionsResult": "{{ count }} sugerencia y ",
    "suggestionsResult_other": "{{ count }} sugerencias y ",
    "productsResult": "{{ count }} producto disponible.",
    "productsResult_other": "{{ count }} productos disponibles.",
    "resetLabel": "Restablecer busqueda",
    "help": {
      "insufficientChars": "Escribe mas caracteres",
      "noMatch": "Sin resultados",
      "exactMatch": "{{ term }}",
      "empty": "Escribe tu busqueda"
    }
  },
  "sorting": {
    "date": "Fecha",
    "orderNumber": "Número de orden",
    "rma": "Número de Devolución",
    "replenishmentNumber": "Número de Reposición",
    "nextOrderDate": "Fecha del Próximo Pedido",
    "pageViewUpdated": "La vista de la página se actualizó con las opciones que seleccionaste."
  },
  "customLoginPage": {
    "badRequest": {
      "bad_credentials": "RUT o contraseña incorrectos",
      "account_disabled": "El usuario está deshabilitado. Por favor, póngase en contacto con la administración.",
      "unknown_error": "Ocurrió un error desconocido. Por favor, inténtelo de nuevo más tarde."
    }
  },
  "httpHandlers": {
    "badRequest": {
      "bad_credentials": "Usuario o contraseña incorrectos.",
      "user_is_disabled": "Por favor, contacta con la administración."
    },
    "badGateway": "Ocurrió un error en el servidor. Por favor, inténtalo de nuevo más tarde.",
    "badRequestPleaseLoginAgain": "Por favor, inicia sesión de nuevo.",
    "badRequestOldPasswordIncorrect": "La contraseña antigua es incorrecta.",
    "badRequestGuestDuplicateEmail": "{{ errorMessage }} el correo electrónico ya existe. Por favor, realiza el checkout con un correo electrónico diferente para registrarte usando una cuenta de invitado.",
    "conflict": "Ya existe.",
    "forbidden": "No estás autorizado para realizar esta acción. Por favor, contacta con tu administrador si crees que esto es un error.",
    "gatewayTimeout": "El servidor no respondió, por favor inténtalo de nuevo más tarde.",
    "internalServerError": "Ocurrió un error interno del servidor. Por favor, inténtalo de nuevo más tarde.",
    "sessionExpired": "Tu sesión ha expirado. Por favor, inicia sesión de nuevo.",
    "unknownError": "Ocurrió un error desconocido",
    "unauthorized": {
      "common": "Ocurrió un error de autorización desconocido",
      "invalid_client": "Credenciales de cliente incorrectas"
    },
    "validationErrors": {
      "missing": {
        "card_cardType": "La tarjeta de crédito seleccionada no es compatible. Por favor, selecciona otra.",
        "card_accountNumber": "El número de tarjeta de crédito introducido no es válido.",
        "card_cvNumber": "El código de seguridad introducido no es válido.",
        "card_expirationMonth": "La fecha de vencimiento de la tarjeta de crédito introducida no es válida.",
        "card_expirationYear": "La fecha de vencimiento de la tarjeta de crédito introducida no es válida.",
        "billTo_firstName": "El nombre introducido no es válido.",
        "billTo_lastName": "El apellido introducido no es válido.",
        "billTo_street1": "La dirección introducida no es válida.",
        "billTo_street2": "La dirección introducida no es válida.",
        "billTo_city": "La ciudad introducida no es válida para esta tarjeta de crédito.",
        "billTo_state": "El estado/provincia introducido no es válido para esta tarjeta de crédito.",
        "billTo_country": "El país/región introducido no es válido para esta tarjeta de crédito.",
        "billTo_postalCode": "El código postal no es válido para esta tarjeta de crédito.",
        "country": {
          "isocode": "Falta país/región"
        }
      },
      "invalid": {
        "card_expirationMonth": "La fecha de vencimiento de la tarjeta de crédito introducida no es válida.",
        "firstName": "El nombre introducido no es válido.",
        "lastName": "El apellido introducido no es válido.",
        "password": "La contraseña introducida no es válida.",
        "uid": "El UID no es válido.",
        "code": "El código no es válido.",
        "email": "El correo electrónico no es válido."
      }
    },
    "cartNotFound": "Carrito no encontrado.",
    "invalidCodeProvided": "Código proporcionado inválido.",
    "voucherExceeded": "Este cupón ha superado el número de veces que puede ser utilizado",
    "unknownIdentifier": "Artículo no encontrado.",
    "otherCartErrors": "Ocurrieron errores en el carrito."
  },
  "miniCart": {
    "item": "{{count}} item currently in your cart",
    "item_other": "{{count}} items currently in your cart",
    "total": "{{total}}",
    "count": "{{count}}"
  },
  "skipLink": {
    "skipTo": "Skip to",
    "labels": {
      "header": "Header",
      "main": "Main Content",
      "footer": "Footer",
      "productFacets": "Product Facets",
      "productList": "Product List"
    }
  },
  "carousel": {
    "previousSlide": "Previous slide",
    "nextSlide": "Next slide",
    "slideNumber": "Slide {{currentSlideNumber}}",
    "carouselForProduct": "Carousel, Images for {{product}}"
  },
  "formErrors": {
    "mask": "Debe ingresar todos los dígitos del RUT",
    "globalMessage": "The form you are trying to submit contains errors.",
    "required": "Este campo es requerido",
    "cxInvalidEmail": "No es un formato válido",
    "cxInvalidPassword": "No es un formato válido para contraseña",
    "cxPasswordsMustMatch": "Password fields must match",
    "cxEmailsMustMatch": "Email fields must match",
    "cxStarRatingEmpty": "Rating field is required",
    "cxNoSelectedItemToCancel": "Select at least one item",
    "cxNegativeAmount": "Amount must be equal or greater than zero",
    "cxContainsSpecialCharacters": "Field cannot contain special characters",
    "date": {
      "required": "Este campo es requerido",
      "min": "Date cannot be before {{min}}",
      "max": "Date cannot be after {{max}}",
      "pattern": "Use dateformat yyyy-mm-dd",
      "invalid": "Use a valid date"
    },
    "file": {
      "required": "File is required",
      "empty": "File should not be empty",
      "invalidExtension": "File extension is not valid",
      "tooLarge": "File size should not exceed {{ maxSize }} MB",
      "tooManyEntries": "The number of items is greater than {{ maxEntries }}",
      "notParsable": "File is not parsable",
      "fileNotAllowed": "This file type is not allowed"
    }
  },
  "errorHandlers": {
    "scriptFailedToLoad": "Failed to load the script.",
    "refreshThePage": "Please refresh the page."
  },
  "assistiveMessage": {
    "actionCancelled": "Action cancelled, nothing changed"
  },
  "passwordVisibility": {
    "showPassword": "Show password",
    "hidePassword": "Hide password"
  },
  "generalErrors": {
    "pageFailure": "The page could not be loaded. Please try again later."
  },
  "chatMessaging": {
    "charactersLeft": "characters left: {{count}}",
    "addNewMessage": "Add New Message",
    "send": "Send",
    "uploadFile": "Upload File",
    "informationLabel": "{{author}}. {{text}} at {{date}}",
    "messages": "Messages",
    "addMessagePlaceHolder": "Start Typing...",
    "characterLimitAlert": "Characters limit reached."
  }
}